module.exports = __webpack_public_path__ + "img/noface.e0a7d75d.gif";